import apiService from './apiService';

export const postCreateUser = async (payload: {}) => {
  try {
    const response = await apiService.post(`users`, payload);
    return response.data;
  } catch (error) {
    console.error('Error posting users:', error);
    throw error;
  }
};

export const getUsers = async (page = 1, search = '') => {
  try {
    const normalizedSearch = search.trim();
    const params = new URLSearchParams({
      page: String(page),
    });

    if (normalizedSearch) {
      params.append('filter[search]', normalizedSearch);
    }

    const response = await apiService.get(`/users?${params.toString()}`);

    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const deleteUserByID = async (id: number | string) => {
  try {
    const response = await apiService.delete(`/users/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting user :', error);
    throw error;
  }
};

export const getUserByID = async (id: number | string) => {
  try {
    const response = await apiService.get(`/users/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user by Id:', error);
    throw error;
  }
};

export const postEditUser = async (id: number | string, payload: any) => {
  try {
    const response = await apiService.put(`/users/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating user by Id:', error);
    throw error;
  }
};

export const postChangePassword = async (id: number | string, payload: any) => {
  try {
    const response = await apiService.post(`/users/change-password`, payload);
    return response.data;
  } catch (error) {
    console.error('Error changing password:', error);
    throw error;
  }
};

export const verifyOldPassword = async (payload: { old_password: string }) => {
  const response = await apiService.post('/users/verify-old-password', payload);

  return response.data;
};
export const getUsersDropdown = async (page = 1, search = '', perPage = 1000) => {
  try {
    const params = new URLSearchParams({
      page: String(page),
      per_page: String(perPage), // check your backend's actual param name: per_page, limit, page_size...
    });

    if (search) {
      params.append('filter[search]', search);
    }

    const response = await apiService.get(`/users?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching users dropdown:', error);
    throw error;
  }
};
